import React from 'react';
import './TabNavigation.css';

export type TabId = 'topics' | 'news-items' | 'user' | string;

export interface Tab {
  id: TabId;
  label: string;
  count?: number;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
  user?: any;
  onLoginClick?: () => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ 
  tabs, 
  activeTab, 
  onTabChange,
  user,
  onLoginClick 
}) => {
  const handleAuthButtonClick = () => {
    if (user) {
      onTabChange('user');
    } else {
      onLoginClick?.();
    }
  };

  return (
    <div className="tab-navigation">
      <div className="tab-list" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`${tab.id}-panel`}
          >
            <span className="tab-label">{tab.label}</span>
            {tab.count !== undefined && (
              <span className="tab-count">({tab.count})</span>
            )}
          </button>
        ))}
      </div>
      
      <div className="auth-section">
        <button 
          className={`auth-button ${user ? 'profile-button' : 'login-button'}`}
          onClick={handleAuthButtonClick}
        >
          {user ? (
            <div className="user-profile">
              <div className="user-avatar">
                {user.email?.charAt(0).toUpperCase() || 'U'}
              </div>
            </div>
          ) : (
            <span>Sign In</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default TabNavigation;